import { render, staticRenderFns } from "./image.vue?vue&type=template&id=16a198fd&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a198fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a198fd')) {
      api.createRecord('16a198fd', component.options)
    } else {
      api.reload('16a198fd', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=16a198fd&scoped=true&", function () {
      api.rerender('16a198fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/files/image.vue"
export default component.exports